import { 
  collection, 
  addDoc, 
  getDocs, 
  getDoc,
  doc, 
  updateDoc, 
  deleteDoc, 
  query, 
  orderBy, 
  where,
  Timestamp 
} from 'firebase/firestore';
import { Employee } from '../types/employee';
import { db } from '../config/firebase';

export const employeeService = {
  // Adicionar funcionário
  async addEmployee(employeeData: Partial<Employee>): Promise<string> {
    try {
      // Filtrar campos undefined para evitar erro do Firebase
      const cleanData: any = {};
      Object.entries(employeeData).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          cleanData[key] = value;
        }
      });
      
      // Adicionar timestamps
      cleanData.createdAt = Timestamp.now();
      cleanData.updatedAt = Timestamp.now();

      const docRef = await addDoc(collection(db, 'employees'), cleanData);
      console.log('Funcionário adicionado com ID:', docRef.id);
      return docRef.id;
    } catch (error) {
      console.error('Erro ao adicionar funcionário:', error);
      throw error;
    }
  },

  // Buscar funcionário por ID
  async getEmployeeById(id: string): Promise<Employee | null> {
    try {
      const employeeRef = doc(db, 'employees', id);
      const employeeDoc = await getDoc(employeeRef);
      
      if (employeeDoc.exists()) {
        const data = employeeDoc.data();
        return {
          id: employeeDoc.id,
          nome: data.nome,
          telefone: data.telefone,
          status: data.status,
          dataNascimento: data.dataNascimento,
        };
      } else {
        console.log('Funcionário não encontrado com ID:', id);
        return null;
      }
    } catch (error) {
      console.error('Erro ao buscar funcionário por ID:', error);
      throw error;
    }
  },

  // Buscar todos os funcionários
  async getEmployees(): Promise<Employee[]> {
    try {
      const q = query(collection(db, 'employees'), orderBy('nome'));
      const querySnapshot = await getDocs(q);
      
      const employees: Employee[] = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        employees.push({
          id: doc.id,
          nome: data.nome,
          telefone: data.telefone,
          status: data.status,
          dataNascimento: data.dataNascimento,
        });
      });

      return employees;
    } catch (error) {
      console.error('Erro ao buscar funcionários:', error);
      throw error;
    }
  },

  // Buscar funcionários ativos
  async getActiveEmployees(): Promise<Employee[]> {
    try {
      console.log('🔍 Iniciando busca por funcionários ativos...');
      
      const q = query(
        collection(db, 'employees'), 
        where('status', '==', 'ativo')
      );
      const querySnapshot = await getDocs(q);
      
      console.log('📊 Documentos encontrados:', querySnapshot.size);
      
      const employees: Employee[] = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        console.log('👤 Funcionário encontrado:', { id: doc.id, nome: data.nome, status: data.status });
        employees.push({
          id: doc.id,
          nome: data.nome,
          telefone: data.telefone,
          status: data.status,
          dataNascimento: data.dataNascimento,
        });
      });

      // Ordenar por nome no lado do cliente
      employees.sort((a, b) => a.nome.localeCompare(b.nome));
      
      console.log('✅ Total de funcionários ativos retornados:', employees.length);
      return employees;
    } catch (error) {
      console.error('❌ Erro ao buscar funcionários ativos:', error);
      throw error;
    }
  },

  // Atualizar funcionário
  async updateEmployee(id: string, employeeData: Partial<Employee>): Promise<void> {
    try {
      const employeeRef = doc(db, 'employees', id);
      
      // Filtrar campos undefined para evitar erro do Firebase
      const cleanData: any = {};
      Object.entries(employeeData).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          cleanData[key] = value;
        }
      });
      
      // Adicionar timestamp de atualização
      cleanData.updatedAt = Timestamp.now();
      
      await updateDoc(employeeRef, cleanData);
      console.log('Funcionário atualizado com sucesso');
    } catch (error) {
      console.error('Erro ao atualizar funcionário:', error);
      throw error;
    }
  },

  // Deletar funcionário
  async deleteEmployee(id: string): Promise<void> {
    try {
      const employeeRef = doc(db, 'employees', id);
      await deleteDoc(employeeRef);
      console.log('Funcionário deletado com sucesso');
    } catch (error) {
      console.error('Erro ao deletar funcionário:', error);
      throw error;
    }
  }
};
